var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.11 9l5.39 6.35 1 2.65-2.504-1.35L.5 9l6.496-7.65L9.5 0l-1 2.65L3.11 9z",
    fill: "#9A9CAC"
  })));
}

export default SvgArrowLeftIcon;